<template>
  <aha-modal
    :noCloseOnBackdrop="true"
    :closable="false"
    :hideHeader="true"
    :classesModal="{'ppt-no-support': true}"
  >
    <div>
      <aha-logo
        class="mt-14 mb-8"
        width="120"
        height="26"
      />
      <h2 class="mb-8">
        AhaSlides isn’t available on PowerPoint Online yet
      </h2>
      <p class="mb-8">
        To use the AhaSlides add-in, please open the PowerPoint desktop app.
      </p>
      <p>
        For further support, please email us at
        <a href="mailto:hi@ahaslides.com" class="text-primary-90 hover:text-primary-100">hi@ahaslides.com</a>
      </p>
    </div>
  </aha-modal>
</template>

<script>
import Util from '@/util'

export default {
  mounted() {
    document.body.classList.add('no-scroll')
    Util.trackGA4AndMixpanel('PowerPoint Addin Online', { method: 'Show screen not support' })
  },
  destroyed() {
    document.body.classList.remove('no-scroll')
  },
}
</script>

<style lang="scss">
.ppt-no-support {
  .aha-modal__content {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }

  .aha-modal__body, .aha-modal__action {
    max-width: 480px;
    margin: 0 auto;
  }
  .aha-modal__header {
    display: none;
  }

  .aha-modal__action {
    justify-content: start;

    .justify-end {
      justify-content: flex-start;
      margin-bottom: 1.8rem;
    }
  }
}
</style>
